/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/destructuring-assignment */
import { ActionIcon, Group, OptionsFilter, Select } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { IconRefresh, IconReportSearch } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { ProposalSearchResponseType } from '../../../models/core/proposals.type';
import proposalsService from '../../../services/core/proposals.service';
import theme from '../../../theme';
import { SessionStorageKey } from '../../../utils/constants.utils';
import { transformComboBoxGroupDataFromV5toV7 } from '../../../utils/mantine.utils';
import ProfileCardLink from '../ProfileCardLink/ProfileCardLink';

type FormViewProps = {
  label: string;
  description: string | null;
  formItem: any;
  idsToBeDisabled: number[];
  disabled: boolean;
  callback(item: ProposalSearchResponseType | null): void;
  zIndex: number;
  useCache: boolean;
};

export default function ProposalPicker(props: FormViewProps) {
  const [data, setData] = useState<ProposalSearchResponseType[]>([]);
  const [loading, setLoading] = useState(false);

  const confirmActionResult = (item: ProposalSearchResponseType | null, confirmed: boolean) => {
    if (!confirmed) {
      return;
    }
    props.callback(item);
  };

  const loadData = async () => {
    try {
      setLoading(true);
      const result = await proposalsService.list();
      setData(result);
      sessionStorage.setItem(SessionStorageKey.ProposalSearch, JSON.stringify(result));
    } catch (error: any) {
      showNotification({
        title: 'Propostas',
        message: error?.isBusinessException ? error.description : 'Não foi possível carregar os propostas.',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.useCache) {
      const cacheResult = JSON.parse(
        sessionStorage.getItem(SessionStorageKey.ProposalSearch) || '[]'
      ) as ProposalSearchResponseType[];

      if (cacheResult.length > 0) {
        setData(cacheResult);
      }
    } else {
      loadData();
    }
  }, []);

  const handleRefresh = () => {
    loadData();
  };

  const optionsFilter: OptionsFilter = ({ options, search }) => {
    if (search.trim().length === 0) {
      return options;
    }

    const filteredData = data
      .filter((x) => {
        const value = `${x.idProposta}|${x.idProposta}|${x.propostaStatus}|${x.clienteNomeFantasia || ''}|${
          x.clienteRazaoSocial || ''
        }|${x.clienteCNPJ || ''}|${x.clienteNome || ''}|${x.clienteCPF || ''}`;
        return value.toLowerCase().includes(search.toLowerCase());
      })
      .map((y) => y.idProposta.toString());

    const filteredOptions = [];
    for (const option of options) {
      const items = (option as any).items.filter((x: any) => filteredData.includes(x.value));
      if (items.length > 0) {
        filteredOptions.push({
          ...option,
          items,
        });
      }
    }
    return filteredOptions;
  };

  return (
    <Group grow preventGrowOverflow={false} wrap="nowrap">
      <Select
        key={`proposal-picker_${props.formItem.value?.toString()}`}
        leftSection={<IconReportSearch size={15} />}
        label={props.label}
        description={props.description || null}
        placeholder="Selecione..."
        data={transformComboBoxGroupDataFromV5toV7(
          data.map((x) => {
            return {
              label: `# ${x.idProposta} - ${
                x.clienteNomeFantasia || x.clienteRazaoSocial || x.clienteNome || ''
              }`,
              value: x.idProposta.toString(),
              disabled: props.idsToBeDisabled.includes(x.idProposta),
              group: x.clienteNomeFantasia || x.clienteRazaoSocial || x.clienteNome || 'Cliente',
            };
          })
        )}
        // clearable
        searchable
        filter={optionsFilter}
        disabled={props.disabled || loading}
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        renderOption={({ option, checked }) => {
          const row = data.find((x) => x.idProposta.toString() === option.value)!;
          return (
            <Group>
              <ProfileCardLink
                id={row.idProposta.toString()}
                name={`Proposta # ${row.idProposta}`}
                nameSize="sm"
                description={`${row.propostaStatus}`}
                descriptionSize="xs"
                showLink={false}
              />
            </Group>
          );
        }}
        required
        {...props.formItem}
        value={props.formItem.value?.toString()}
        onOptionSubmit={(value: string) => {
          confirmActionResult(data.find((x) => x.idProposta.toString() === value) || null, true);
        }}
        comboboxProps={{ zIndex: props.zIndex + 1 }}
      />
      <ActionIcon
        style={{ marginLeft: -10, marginTop: props.description ? 40 : 20, maxWidth: 15 }}
        radius="sm"
        color="primary"
        variant="outline"
        onClick={handleRefresh}
        disabled={props.disabled || loading}
        loading={loading}
      >
        <IconRefresh size={15} color={theme?.colors?.primary?.[6]} />
      </ActionIcon>
    </Group>
  );
}
